<template>
  <div
    class="call-to-action"
    ref="container" v-show="isOpen || response"
  >
    <div
      class="overlay overlay-info"
      :class="{ open: isOpen}"
      ref="overlay"
    >
      <button type="button" class="btn btn-overlay-close toggle-btn" @click="closeOverlay">
        ×
      </button>

      <VuePerfectScrollbar class="scroll-area" ref="ps1">
        <div class="container-fluid">
          <div class="row">
            <div class="h-100 col-lg-12">
              <div class="row">
                <div class="video-info-form">
                  <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show"
                          :class="{ 'was-validated': $v.form.$anyDirty }" novalidate ref="form">
                    <b-row>
                      <b-col>
                        <h3><span class="form-title">  {{ $t('dark-skin.contact-form.title') }}</span></h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>

                        <div class="form-group">
                          <label for="input-name" class="required primary">{{
                            $t('dark-skin.contact-form.name')
                            }}<span style="color: red">*</span></label>
                          <input
                            type="text"
                            v-model="form.name"
                            id="input-name"
                            name="title"
                            class="form-control"
                            required
                          />
                          <div v-if="!$v.form.name.required" class="invalid-feedback">
                            {{ $t('dark-skin.email-modal.messages.field-required') }}
                          </div>
                        </div>
                      </b-col>

                      <b-col>
                        <div class="form-group">
                          <label for="input-name" class="required primary">{{
                            $t('dark-skin.contact-form.lastName')
                            }}<span style="color: red">*</span></label>
                          <input
                            type="text"
                            v-model="form.lastName"
                            id="input-lastName"
                            name="title"
                            class="form-control"
                            required
                          />
                          <div v-if="!$v.form.lastName.required" class="invalid-feedback">
                            {{ $t('dark-skin.email-modal.messages.field-required') }}
                          </div>
                        </div>
                      </b-col>

                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="form-group">
                          <label for="input-email" class="required primary">{{
                            $t('dark-skin.contact-form.email')
                            }}<span style="color: red">*</span></label>
                          <input
                            type="email"
                            v-model="form.from"
                            id="input-email"
                            name="title"
                            class="form-control"
                            required
                          />
                          <div v-if="!$v.form.from.email" class="invalid-feedback">
                            {{ $t('dark-skin.email-modal.messages.invalid-email') }}
                          </div>
                          <div v-if="!$v.form.from.required" class="invalid-feedback">
                            {{ $t('dark-skin.email-modal.messages.field-required') }}
                          </div>
                        </div>

                      </b-col>

                      <b-col>
                        <b-form-group
                          id="input-group-tel"
                          :label="$t('dark-skin.contact-form.tel')"
                          label-for="input-tel"
                        >
                          <b-form-input
                            id="input-tel"
                            v-model="form.tel"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          id="input-group-soc"
                          :label="$t('dark-skin.contact-form.soc')"
                          label-for="input-soc"
                        >
                          <b-form-input
                            id="input-soc"
                            v-model="form.soc"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col>
                        <b-form-group
                          id="input-group-function"
                          :label="$t('dark-skin.contact-form.function')"
                          label-for="input-function"
                        >
                          <b-form-input
                            id="input-function"
                            v-model="form.function"
                            type="text"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group
                          :label="$t('dark-skin.contact-form.text')"
                          label-for="input-text"
                          class="form-group"

                        >
                          <b-form-textarea
                            id="input-text"
                            v-model="form.text"
                            rows="3"
                            no-resize
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>


                    </b-row>
                    <b-row>
                      <b-col>
                        <div class="position-button">
                          <a href="https://www.empreinte.com/" target="_blank" class="position-button__link">{{$t('dark-skin.contact-form.link')}}</a>
                          <b-button type="submit" variant="secondary" class="position-button__submit"
                                    :disabled="sendInProgress">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g> <g> <polygon points="361,277.213 316,322.213 271,277.213 141.213,407 490.787,407 		"/> </g> </g>
                              <g> <g> <polygon points="120,126.213 120,385.787 249.787,256 		"/> </g> </g>
                              <g> <g> <polygon points="141.213,105 316,279.787 490.787,105 		"/> </g> </g>
                              <g> <g> <polygon points="382.213,256 512,385.787 512,126.213 		"/> </g> </g>
                              <g> <g> <rect y="377" width="90" height="30"/> </g> </g>
                              <g> <g> <rect y="309" width="90" height="30"/> </g> </g>
                              <g> <g> <rect y="241" width="90" height="30"/> </g> </g>
                              <g> <g> <rect y="173" width="90" height="30"/> </g> </g>
                              <g> <g> <rect y="105" width="90" height="30"/> </g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g>
                              <g> </g> </svg>
                            <span v-if="sendInProgress">
            {{ $t('dark-skin.email-modal.sending') }}
          </span>
                            <span v-else="sendInProgress">{{ $t('dark-skin.email-modal.send') }}</span>
                          </b-button>
                        </div>
                      </b-col>


                    </b-row>

                  </b-form>

                </div>

              </div>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>

    <div class="emailModal__overlay modal-dialog" ref="'modal-dialog-contact'" :class="response.class" v-if="response">
           <div @click="closeModal">
               <img
                       src="../static/images/close.svg"
                       class="close-modal emailModal__overlay__image"
                       alt=""

               />
           </div>

      <img
        v-if="response.class === 'success'"
        src="../static/images/success.png"
        class="emailModal__overlay__image"
        alt=""
      />
      <img
        v-else="response.class === 'success'"
        src="../static/images/error.png"
        class="emailModal__overlay__image"
        alt=""
      />
      <h2 class="emailModal__overlay__title">  {{ $t('dark-skin.contact-form.contact') }}</h2>
      <p class="emailModal__overlay__message">{{ $t('dark-skin.contact-form.description') }}</p>
      <div class="emailModal__overlay__action">
          <button class="button-redirect btn btn-primary emailModal__overlay__btn" @click="handleMessageButton">
         <a target="_blank" href="https://www.empreinte.com/"> {{ response.button }}</a>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import en from '../i18n/en_US';
  import fr from '../i18n/fr_FR.js';
  import {required, email} from 'vuelidate/lib/validators';
  import {HTTP} from '../core/http/http-common';
  import i18n from '../i18n/index.js';

  import 'vue-context/dist/css/vue-context.css';

  export default {
    components: {
      VuePerfectScrollbar,
    },
    i18n: {
      messages: {
        en: en,
        fr: fr,
      },
    },
    name: 'mail-call-to-action',
    props: {
      emailOptions: Object,
      player:Object
    },
    validations: {
      form: {
        name: {required},
        lastName: {required},
        from: {required, email},
      }
    },
    data() {
      return {
        isOpen: false,/*to do true et false*/
        sendInProgress: false,
        form: {
          name: '',
          lastName: '',

        },
        show: true,
        response: null
      };
    },
    computed: {},
    methods: {
      handleMessageButton() {
        if (this.response.class === 'success') {
          this.$v.form.$reset();

          setTimeout(() => {
            this.form = {
              email: '',
              from: '',
              subject: '',
              message: '',
            };
          }, 500);
        }
        setTimeout(() => {
          this.response = null;
        }, 500);

      },
      closeOverlay() {
        this.isOpen = false;
      },
      onSubmit(evt) {
        evt.preventDefault()
        console.log(this.$v.form)
        this.$v.form.$touch();
        if (this.$v.form.$error) {
          return;
        }

        this.sendInProgress = true;
        const contentSendMail = {
          cryptedParam: this.emailOptions.cryptedParam,
          to: "amina.xpermedia@gmail.com",
          type: "cta",
          from: this.form.from,
          title: this.form.subject ? this.form.subject : this.form.name+" "+this.form.lastName,
          message: this.form.text ? this.form.text : "message vide",
          function: this.form.function ? this.form.function : "message vide",
          tel: this.form.tel ? this.form.tel : "message vide",
          soc: this.form.soc ? this.form.soc : "message vide",
        };
        const URL = this.emailOptions.URL;
        let self = this;
        this.sendInProgress = true;
        HTTP.post(URL, contentSendMail, {
          emulateJSON: true,
        }).then(
          response => {
            if (response.data.code === 200) {
              self.response = {
                class: 'success',
                image: '../../static/images/success.png',
                title: i18n.t('dark-skin.email-modal.messages.thank-you'),
                message: i18n.t('dark-skin.email-modal.messages.message-sent'),
                button: i18n.t('dark-skin.email-modal.messages.back-to-video'),
              };
            } else {
              self.response = {
                class: 'error',
                image: '../../static/images/error.png',
                title: i18n.t('dark-skin.email-modal.messages.oops'),
                message: i18n.t('dark-skin.email-modal.messages.error-occurred'),
                button: i18n.t('dark-skin.email-modal.messages.try-again'),
              };
            }
            self.sendInProgress = false;
            self.isOpen = false;
          },
          function (response) {
            console.error('api error', response);
            self.sendInProgress = false;
            self.response = {
              class: 'error',
              image: '../../static/images/error.png',
              title: i18n.t('dark-skin.email-modal.messages.oops'),
              message: i18n.t('dark-skin.email-modal.messages.error-occurred'),
              button: i18n.t('dark-skin.email-modal.messages.try-again'),
            };
            self.isOpen = false;
            self.sendInProgress = false;
          },
        );

        //alert(JSON.stringify(this.form))
      },
        closeModal(){
          this.response=!this.response
        },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form.name = ''
        this.form.lastName = ''
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }

    },
    updated() {
    },
    mounted() {
      let self = this;
      this.$i18n.locale = localStorage.getItem('lang-player');
      this.player.on('ended', function() {
        self.isOpen = true;
        self.player.bigPlayButton.hide();
        self.player.controlBar.hide();
      });
      this.player.on('play', function() {
          self.isOpen = false;
          self.player.bigPlayButton.show();
          self.player.controlBar.show();
        }
      );
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/skin/dark/grid';

  @mixin medium-width {
    .overlay.overlay-info {
      padding: 2em 1em;

      .container-fluid {
        height: auto;
        max-height: initial;
        max-width: 600px;

        .scroll-area,
        .info__flex {
          height: auto;
          max-height: initial;
        }
      }
    }
  }

  .call-to-action {
    font-family: 'RobotoUep', sans-serif, Arial;
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 1.5;
    height: 100%;
    background: transparent;
    position: fixed;
    z-index: 11;
    width: 100%;

    .b-b {
      border-bottom: 1px solid rgba(158, 158, 158, 0.5);
    }

    color: #efefef;

    .btn {
      color: #ffffff;

      &.toggle-btn {
        position: absolute;
        top: 0;
        z-index: 2;
        margin: 1vw;
        font-size: 1.2em;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);

        &.btn-overlay-close {
          right: 0;
          position: absolute;
          font-size: 1.2em;
          border: 2px solid white;
          font-weight: bold;
          padding: 0.4em;
          line-height: 0.6em;
          width: 30px;
          height: 30px;
          opacity: 0.9;
          transition: opacity 0.2s ease;

          &:hover {
            opacity: 1;
          }
        }

        &.btn-info-dark {
          left: 0;
        }
      }
    }

    .overlay.overlay-info {
      padding: 3em 2em;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.8);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.5s, visibility 0.5s;
      z-index: 3; // To be over the RM resizer
      overflow: auto;

      &.open {
        opacity: 1;
        visibility: visible;
      }

      &.reduced {
        width: 50%;
      }

      > .scroll-area {
        height: 100%;
      }

      h6 {
        margin-bottom: 1.5em;

        &.m-b-5 {
          margin-bottom: 0.5em;
        }

        &.p-b {
          padding-bottom: 0.8em;
        }

        &.collapsible {
          cursor: pointer;
        }

        .icon {
          font-size: 0.8em;
          margin-left: 1em;
          vertical-align: middle;
        }
      }

      .position-button {
        position: absolute;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        width: 97%;

        &__link {
          left: 0;
          float: left;
          text-align: center;
          align-items: center;
          position: absolute;
        }

        &__submit {
          right: 0;
          float: right;
          position: absolute;
          display: flex;
          flex-direction: row;
          justify-content: center;
          vertical-align: middle;
          text-align: center;
          background: #939393;

          span {
            color: rgba(33, 33, 33, 0.8);
            padding: 0 0.2em;
          }

          svg {
            fill: rgba(33, 33, 33, 0.8);
            width: 25px;
            height: 25px;
          }
        }
      }

      .video-info-form {
        /* padding: 5em 15em; */
        /* padding: 5em 15em; */
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        position: relative;
        right: 20em;
        top: 10em;
        color: white;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        left: 0;

        .form-title {
          display: flex;
          justify-content: center;
        }

        $inputs-form: name, lastName, email, tel, soc, function, text;

        @each $input in $inputs-form {
          #input-#{$input} {
            background: rgba(33, 33, 33, 0.8);
            border: 1px solid #808080;
            color: white;
          }
        }

      }

    }

    /*
     * UI enhancement
     */

    .link-copied-success + .copied-msg {
      opacity: 1;
      visibility: visible;
    }

    .form-control {
      &.link-copied-success {
        border-color: #4caf50 !important;
        box-shadow: 0 0 0.2rem 0 rgba(76, 175, 80, 0.6) !important;
        background-color: rgba(76, 175, 80, 0.4) !important;
      }
    }

    .v-context {
      color: #333333 !important;
    }

    /*
     * Customization for perfect scrollbar
     */
    .container-fluid {
      height: 100%;
      overflow: hidden;
      padding-bottom: 1em;
      max-height: calc(100vh - 6em);

      .row {
        /*height: 100%;*/
        .info__flex {
          max-height: 100%;
          display: flex;
          flex-direction: column;

          h6,
          .general-info-wrapper {
            flex-shrink: 0;
          }

          .description {
            word-break: break-word;
            padding-bottom: 15px;
            margin-bottom: 20px;
          }
        }
      }

      .scroll-area {
        max-height: 100%;
        padding-right: 1em;
      }
    }

    .scroll-area {
      /deep/ .ps__scrollbar-y-rail {
        background-color: transparent !important;
        border-radius: 15px;

        &:hover {
          background-color: transparent;

          .ps__scrollbar-y {
            background-color: #999;
            width: 8px;
          }
        }
      }
    }

    .emailModal__overlay {
      position: relative;
      padding: 10px;
      background: white;
      pointer-events: inherit !important;

      .emailModal__overlay__action {
        display: flex;
        justify-content: space-evenly;
      }
    }


    /*
     * Mobile responsivity
     */

    @media (max-width: $medium-width) {
      @include medium-width;
    }
.close-modal{
    position: absolute;
    right: 20px;
    width: 15px;
    cursor: pointer;
}
      .button-redirect{
          cursor: pointer;
          a{
              color:white!important;
              text-decoration: none;
          }

      }
  }
</style>



// WEBPACK FOOTER //
// src/components/MailCallToAction.vue